export const getDocumentTypeName = (documentType: string): string => {
  const names: Record<string, string> = {
    'standard-residential': 'Standard Residential Tenancy Agreement',
    'commercial-lease': 'Commercial Lease Agreement',
    'student-accommodation': 'Student Accommodation Agreement',
    'deposit-protection': 'Tenancy Deposit Protection Notice',
    'rent-increase': 'Rent Increase Notice',
    'property-inspection': 'Property Inspection Checklist',
    'inventory-report': 'Inventory and Condition Report',
    'right-to-rent': 'Right to Rent Checklist',
    'mediation-agreement': 'Mediation Agreement Template',
    'dispute-framework': 'Dispute Resolution Framework',
    'mediation-request': 'Mediation Request Form',
    'evidence-collection': 'Evidence Collection Checklist',
    'communication-log': 'Communication Log Template',
    'settlement-agreement': 'Settlement Agreement Template',
    'mediation-guide': 'Mediation Process Guide',
    'dispute-assessment': 'Dispute Category Assessment',
    'section8-ground8': 'Section 8 Notice - Ground 8 (Serious Rent Arrears)',
    'section8-ground14': 'Section 8 Notice - Ground 14 (Anti-social Behaviour)',
    'possession-claim': 'Possession Claim Form N5',
    'witness-statement': 'Witness Statement Template',
    'rent-arrears-schedule': 'Rent Arrears Schedule',
    'section8-assessment': 'Section 8 Grounds Assessment Tool',
    'pre-action-protocol': 'Pre-Action Protocol Checklist',
    'court-bundle': 'Court Bundle Template',
    'lease-rewrite': 'Rewritten Tenancy Agreement',
    'periodic-tenancy': 'Periodic Tenancy Agreement',
    'written-statement-prescribed-terms': 'Written Statement of Prescribed Terms',
    'section-13-notice': 'Section 13 Rent Increase Notice'
  };

  return names[documentType] || documentType.split('-').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ');
};
